import React, { useMemo } from "react";
import { Typography } from "../Typography/Typography";
//
import { useFieldErrorMessage } from "../inputUtils";
import type { FieldError } from "react-hook-form";

export interface SelectInputChoice<T extends string = string> {
  value: T;
  label: string;
  slug?: string;
}

interface SelectInputProps extends React.InputHTMLAttributes<HTMLSelectElement> {
  label: string;
  choices: SelectInputChoice[];
  isRequired: boolean;
  includeEmptyOption?: boolean;
  name: string;
  hookFormFieldError: FieldError | undefined;
}

export const SelectInput = React.forwardRef<HTMLSelectElement, SelectInputProps>((props, ref) => {
  const { label, choices, isRequired, hookFormFieldError, includeEmptyOption = true, ...inputProps } = props;

  const error = useFieldErrorMessage(hookFormFieldError);

  const inputStyle = useMemo(() => {
    const borderClassName = error ? "border-red" : "border-grey";
    return `${borderClassName} mt-1 min-h-12 min-w-full rounded-xl border pl-1 focus:shadow-focus-glow`;
  }, [error]);

  return (
    <>
      <Typography className={error ? "text-red" : ""}>
        {props.label}
        {isRequired ? "*" : ""}
      </Typography>
      {error ? <p className="text-red">{error} </p> : null}
      <select {...inputProps} className={inputStyle} ref={ref}>
        {includeEmptyOption ? <option value="" /> : null}
        {choices.map((choice, idx) => {
          return (
            <option value={choice.value} key={idx}>
              {choice.label}
            </option>
          );
        })}
      </select>
    </>
  );
});

SelectInput.displayName = "RadioSelectInput";
